import { supabase } from "@/integrations/supabase/client";

export interface EventLookupService {
  getEventBySlug(slug: string): Promise<{ id: string; slug: string; title: string | null } | null>;
}

export interface SocialDataService {
  countPhotoLikes(photoId: string): Promise<number>;
  listComments(photoId: string): Promise<Array<Record<string, unknown>>>;
}

export interface AdminOpsService {
  createOrder(payload: Record<string, unknown>): Promise<void>;
}

export const supabaseEventLookupService: EventLookupService = {
  async getEventBySlug(slug) {
    const { data } = await supabase.from("events").select("id, slug, title").eq("slug", slug).maybeSingle();
    return data;
  },
};

export const supabaseSocialDataService: SocialDataService = {
  async countPhotoLikes(photoId) {
    const { count } = await supabase.from("photo_likes").select("photo_id", { count: "exact", head: true }).eq("photo_id", photoId);
    return count ?? 0;
  },

  async listComments(photoId) {
    const { data } = await supabase.from("photo_comments").select("*").eq("photo_id", photoId).order("created_at", { ascending: true });
    return (data ?? []) as Array<Record<string, unknown>>;
  },
};

export const supabaseAdminOpsService: AdminOpsService = {
  async createOrder(payload) {
    const { error } = await supabase.from("orders").insert(payload as any);
    if (error) throw error;
  },
};
